/**
 * @generated SignedSource<<8081e5694135a10cc62137e48c7fc6e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RichTextCell$data = {
  readonly fieldId: string;
  readonly richText: {
    readonly adfValue: {
      readonly convertedPlainText?: {
        readonly plainText: string | null | undefined;
      } | null | undefined;
      readonly json?: AGG$JSON | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "RichTextCell";
};
export type RichTextCell$key = {
  readonly " $data"?: RichTextCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"RichTextCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    }
  ],
  "kind": "Fragment",
  "name": "RichTextCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "concreteType": "JiraRichText",
      "kind": "LinkedField",
      "name": "richText",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraADF",
          "kind": "LinkedField",
          "name": "adfValue",
          "plural": false,
          "selections": [
            {
              "condition": "isDensityFull",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "concreteType": "JiraAdfToConvertedPlainText",
                  "kind": "LinkedField",
                  "name": "convertedPlainText",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "plainText"
                    }
                  ]
                }
              ]
            },
            {
              "condition": "isDensityFull",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "json"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraRichTextField"
};

(node as any).hash = "6f3718a989b4562bd8841af8ae1ead93";

export default node;
